module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("\n        门店管理系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('el-menu', {
    ref: "menu",
    attrs: {
      "router": true,
      "theme": "none",
      "default-active": _vm.activePath
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/shop/main/index"
    }
  }, [_c('span', {
    staticClass: "home",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/shop/main/device/list"
    }
  }, [_c('span', {
    staticClass: "coach",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("设备管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/shop/main/type/list"
    }
  }, [_c('span', {
    staticClass: "course",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("设备类型")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/shop/main/staff/list"
    }
  }, [_c('span', {
    staticClass: "activity",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("员工管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/shop/main/order/list"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v("使用订单")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/shop/main/recharge/list"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-share"
  }), _vm._v("充值订单")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b373e0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/Sidebar.vue
// module id = 1153
// module chunks = 2